import React, { useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { AddCategory, Category, ECommerce, SearchTableButton } from "../../../../Constants/Constants";
import { CategoryPageTableData, CategoryPageTableDataColumn } from "../../../../Data/Applications/ECommerce/ECommerce";
import { CollapseFilterData } from "./CollapseFilterData";
import { ProductListFilterHeader } from "./ProductListFilterHeader";

const CategoryPageContainer = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems = CategoryPageTableData.filter((item) => {
    return Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase()));
  });

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <>
      <Breadcrumbs mainTitle={Category} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <ProductListFilterHeader ButtonName={AddCategory}/>
                  <CollapseFilterData />
                </div>
                <div className="datatable-container category-page">
                  <div className="table-responsive">
                    <DataTable className="datatable-table custom-scrollbar" data={filteredItems} columns={CategoryPageTableDataColumn} highlightOnHover pagination selectableRows subHeader subHeaderComponent={subHeaderComponentMemo} />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CategoryPageContainer;
